<script>
  export let progress
  export let inModal

  function get_perc_complete() {
    return Math.round(progress.watched/progress.total*100); 
  }
</script>
<div class="vec-flex vec-w-full vec-flex-col lg:vec-flex-row vec-items-center {(inModal)?"vec-py-4 vec--mt-4":""} vec-bg-gradient-to-b vec-from-white vec-via-white">
  <div class="vec-text-xs xl:vec-text-sm vec-uppercase md:vec-mr-2 vec-whitespace-nowrap vec-w-full lg:vec-w-auto vec-mb-1 lg:vec-mb-0">
    {get_perc_complete()}% Completed
  </div>
  <div class="vec-border-[3px] vec-border-lightGrey vec-overflow-hidden vec-bg-lightGrey vec-rounded-full vec-w-full vec-stretch vec-h-5">
    {#if get_perc_complete() > 1}
    <div class="vec-h-full vec-bg-cut2dDesktop" style="width:{get_perc_complete()}%"></div>
    {/if}
  </div>
</div>
